// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VyUB","rootMobile":"styles_rootMobile__7JY8l"};